import {AxiosRequestConfig, AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';

export const saveProduct = (payload: any): Promise<AxiosResponse> => HttpRequest.post('api/products/update_or_create', payload);

export const productList = (): Promise<AxiosResponse> => HttpRequest.post('api/products/list');

export const deleteProduct = (config: AxiosRequestConfig): Promise<AxiosResponse> => HttpRequest.delete('api/products/delete', config);

export const getProduct = (config: AxiosRequestConfig): Promise<AxiosResponse> => HttpRequest.get('api/products', config);

export const getTaxesData = (): Promise<AxiosResponse> => HttpRequest.get('api/auth/getTaxesData');

export const getTUnitData = (): Promise<AxiosResponse> => HttpRequest.get('api/products/getUnitsData');
